"use strict";
module.exports = require("./DataTable.vue");
